import Vue from 'vue';
import App from './App.vue';
import router from './router/main';
import store from './store';
import VModal from 'vue-js-modal';
import VeeValidate from 'vee-validate';
import Vue2TouchEvents from 'vue2-touch-events';
import vClickOutside from 'v-click-outside';
import HttpHelper from '@/helpers/http';
import VTooltip from 'v-tooltip';
import AnalyticHelper from '@/helpers/analytic';
import { setEnvironment } from '@streamlabs-core/sl-one-fe-sdk';
import { setEnvironment as setSdkEnvironment, componentState } from '@streamlabs-core/sl-one-fe-components-vue2';

Vue.use(VeeValidate);
Vue.use(VModal, { componentName: 'v-modal' });
Vue.use(Vue2TouchEvents);
Vue.use(vClickOutside);
Vue.use(VTooltip);
Object.defineProperty(Vue.prototype, '$http', { value: HttpHelper });
Object.defineProperty(Vue.prototype, '$sla', { value: AnalyticHelper });

import '@/less/app.less';

setEnvironment(process.env.MIX_SL_ID_ENV, {
  services: {
    identity: {
      pk: process.env.MIX_SL_ID_PUBLIC_KEY,
    },
  },
});

setSdkEnvironment(process.env.MIX_SL_ID_ENV, {
  services: {
    identity: {
      pk: process.env.MIX_SL_ID_PUBLIC_KEY,
    },
  },
});

componentState.setCompanyId('studio');
componentState.setForceVerify(true);

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
